<template>
  <div class="app-page">
    <PageHeader type="back" title="Role Change" />
    <div class="application-page-container">
      <a-form
        layout="vertical"
        ref="form"
        :model="formData"
        @finish="formFinish"
        :rules="validateRules"
      >
        <a-form-item :label="$t('admin.Employee LLID')" name="a_LLID">
          <a-input
            v-model:value="formData.a_LLID"
            placeholder="Please Input"
            :disabled="formData.id != 'new'"
          ></a-input>
        </a-form-item>

        <a-form-item :label="$t('admin.LLID of Review Manager')" name="b_LLID">
          <a-input
            v-model:value="formData.b_LLID"
            placeholder="Please Input"
          ></a-input>
        </a-form-item>

        <a-form-item :label="$t('admin.LLID of HRBP')" name="c_LLID">
          <a-input
            v-model:value="formData.c_LLID"
            placeholder="Please Input"
          ></a-input>
        </a-form-item>

        <a-form-item class="form-btn-groups">
          <a-popconfirm
            :title="
              $t('admin.If you leave before saving, your changes will be lost')
            "
            v-if="dirty"
            @confirm="$router.back"
            :okText="$t('admin.OK')"
            :cancelText="$t('admin.Cancel')"
          >
            <a-button class="btn-back">{{ $t('admin.Back') }}</a-button>
          </a-popconfirm>
          <a-button class="btn-back" @click="$router.back" v-else>
            {{ $t('admin.Back') }}
          </a-button>
          <a-button type="primary" html-type="submit" :loading="loading">
            {{ $t('admin.Save') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader.vue'
import { getEmployeeDetail, changeEmployee } from '@/api/admin'
import { message } from 'ant-design-vue'
import { toRaw } from '@vue/reactivity'
import i18n from '../../../locales'

export default {
  name: 'Index',
  components: {
    PageHeader,
  },
  data() {
    const validateRules = {}
    const inputFileds = ['a_LLID', 'b_LLID', 'c_LLID']
    inputFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: 'Please Input',
          trigger: 'blur',
        },
      ]
    })

    return {
      loading: false,
      dirty: false,
      formData: {},
      validateRules,
      eId: null,
    }
  },
  watch: {
    formData: {
      handler: function (n, o) {
        this.dirty = true
      },
      deep: true,
    },
  },
  created() {
    const eid = this.$route.params.id
    if (eid) {
      this.formData.id = eid
      this.eId = eid
      getEmployeeDetail(eid).then((res) => {
        if (res.code == 200) {
          const { employee, lm, hrbp } = res.data

          this.formData = {
            a_LLID: employee.lion_id,
            b_LLID: lm.lion_id,
            c_LLID: hrbp.lion_id,
          }
          let that = this
          setTimeout(() => {
            that.dirty = false
          }, 50)
        }
      })
    }
  },
  methods: {
    formFinish() {
      this.loading = true
      const data = toRaw(this.formData)
      let that = this
      changeEmployee(this.eId, data)
        .then(
          (res) => {
            message.success(
              i18n.global.locale == 'en-US'
                ? 'You have successfully updated employee information.'
                : '你已经成功更新潜力狮的信息'
            )
            if (res.data !== 0) {
              return that.$router.back()
              // return this.$router.push(
              //   `/master/permission/employee_detail/${this.eId}`
              // )
            }
          },
          (err) => {
            if (err.code == 300307) {
              message.error(this.$t('admin.Please enter the correct LionID'))
            } else {
              message.error(`Error Code:${err.code}`)
            }
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import url('@/styles/params.less');
.application-page-container {
  margin: @app-conetent-margin;
  background-color: white;
  padding: 24px;
}
.ant-form-vertical .ant-form-item {
  display: inline-block;
  width: 230px;
  margin-right: 70px;
}
.form-btn-groups {
  width: 100% !important;
  .ant-btn {
    width: 88px;
    margin-right: 16px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .ant-form-item:nth-child(3n + 3) {
    margin-right: 0;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1640px) {
  .ant-form-item:nth-child(4n + 4) {
    margin-right: 0;
  }
}
</style>
